module.exports = __webpack_public_path__ + "static/img/3-msg.518b043.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/3-msg.png
// module id = x2U7
// module chunks = 1